<template>
  <div class="form-view__powered-by">
    Powered by
    <Logo
      class="form-view__powered-by-logo"
      alt="CRM Canis"
    />
  </div>
</template>

